import Component from '../Component';
import PIXIRenderer from '../../System/Render/PIXIRenderer';
import PIXIViewport = require('pixi-viewport');
import Viewport from '../../Prototype/Viewport';

export default class ViewportComponent extends Component<
    PIXIViewport,
    Viewport
> {
    protected onAttach(gameObject: Viewport, container: PIXIViewport): void {
        // Currently only handling single world map viewport.
        PIXIRenderer.mapViewport = container;

        PIXIRenderer.mapViewport.position.set(
            gameObject.container.x + PIXIRenderer.renderer.width * 0.5,
            gameObject.container.y + PIXIRenderer.renderer.height * 0.5
        );

        PIXIRenderer.resizeViewport(
            PIXIRenderer.renderer.width,
            PIXIRenderer.renderer.height
        );
    }

    set drag(value: {}) {
        this.container.drag(value);
    }

    set decelerate(value: { friction: number }) {
        this.container.decelerate(value);
    }

    set clamp(value: { direction: 'all' }) {
        this.container.clamp(value);
    }
}
